// Omnix/client/ui/PhoneNumberManager.js
import { ComponentBase } from "../core/ComponentBase.js";

export class PhoneNumberManager extends ComponentBase {
    constructor(config) {
        super(config);
        this.dataCrud = null;
        this.eventGroup = `${this.config.instanceId || 'userManager'}-view`;

    }

    async initialize() {
        this.dataCrud = await this.createManagedComponent("DataCrud", null, {
            instanceId: `${this.config.instanceId}-crud`,
            rpcClass: "PhoneNumberManagerRpc", // From CommunicatorPlugin
            schemaPath: "collections/telephonyDIDs", // From CommunicatorPlugin
            title: "PBX Phone Numbers (DIDs)",
            viewConfig: {
                mode: 'grid',
                fields: [
                    { name: 'phoneNumber', label: 'Phone Number' },
                    { name: 'provider', label: 'Provider', render: (val) => val === 'manual' ? `<span class="badge bg-secondary">${val}</span>` : `<span class="badge bg-info text-dark">${val}</span>` },
                    { name: 'inboundVoiceWorkflowId', label: 'Inbound Workflow', reference: { collection: 'workflows', valueField: '_id', displayField: 'name', filter: { tags: 'voice' } } },
                    { name: 'createdAt', label: 'Associated On', render: (val) => new Date(val).toLocaleString() },
                ],
                // Enable the create button for manual entry
                toolbar: { create: { enabled: true, label: "Add Number" } }
            },
            formConfig: {
                fields: {
                    phoneNumber: {
                        type: 'text',
                        label: 'Phone Number (E.164 format, e.g., +15551234567)',
                        required: true
                    },
                    provider: {
                        type: 'select',
                        label: 'Provider',
                        required: true,
                        options: [
                            { value: 'manual', label: 'Manual / Other SIP Trunk' },
                            { value: 'twilio', label: 'Twilio (Auto-Managed)' },
                            { value: 'signalwire', label: 'SignalWire (Auto-Managed)' }
                        ],
                        default: 'manual'
                    },
                    inboundVoiceWorkflowId: {
                        type: 'reference',
                        label: 'Inbound Voice Workflow',
                        reference: { collection: 'workflows', valueField: '_id', displayField: 'name', filter: { tags: 'voice' } }
                    }
                }
            },
            dataConfig: { autoLoad: false },
        });
        await super.initialize();
    }

    async initAfterLogin() {
        if (this.dataCrud) {
            this.dataCrud.refreshData();
        }
    }


    async render() {
        return await this.dataCrud.render();
    }

    destroy() {
        this.dataCrud?.destroy();
        super.destroy();
    }
}
